import React, { useState } from 'react';
import BG from '~/components/background';
import useAuth from '~/hooks/useAuth';
import apiCall, { LIVE_URL } from '~/utils/apiCall';

import proBridge from '~/utils/pro-bridge';
import btn from './images/btn_01.png';
import img01 from './images/img_01.png';
import img02 from './images/img_02.png';
import shadow from './images/img_shadow.png';
import text01 from './images/text_01.png';

import { Wrap, ButtonWrap, NoticWrap, Checkbox, Label, BoxWrap, ArrowWrap } from './styled';

function DownIcom() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 10L13.5 19.5L23 10" stroke="#A1ABC2" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function UpIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 17L13.5 7.5L23 17" stroke="#A1ABC2" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
function ProEventComponent() {
  const { authKey } = useAuth();
  const [agree1, setAgree1] = useState(false);
  const [step1, setstep1] = useState(false);

  async function onClickCheck() {
    if (!agree1) return alert('개인정보 수집/이용 에 대한 동의를 체크 해주세요.');
    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/pro/event/2021/12/marketing`, { authKey });
      const errorCode = [501, 502, 503, 504, 506, 507];

      if (errorCode.includes(res.code)) {
        alert(res.msg);
        if (res.code === 501) {
          proBridge.ios(call => {
            call.callHandler('ObjC Echo', {
              cmd: 'showLoginAndReload',
            });
          });

          proBridge.android(call => {
            console.log('android');
            call.showLoginAndReload();
          });
        }
      } else if (res.code === 200) {
        alert("응모 완료 되었습니다.");

        proBridge.android(call => {
          call.finishActivity();
        });
    
        proBridge.ios(call => {
          call.callHandler('iOS Echo', {
            cmd: 'finishActivity',
          });
        });
      }
    } catch (error) {
      console.log(error);
      alert(error?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return (
    <div>
      <Wrap>
        <BG width={710} height={1481} imgUrl={img01} />
        <ButtonWrap onClick={onClickCheck}>
          <BG width={484} height={125} imgUrl={btn} />
        </ButtonWrap>
      </Wrap>
      <BG width={710} height={44} imgUrl={shadow} />

      <NoticWrap>
        <BoxWrap>
          <Label>
            <Checkbox type="checkbox" checked={agree1} onChange={() => { setAgree1(prev => !prev); setstep1(true); }} />
            <p>개인정보 수집/이용 에 대한 동의</p>
          </Label>
          <ArrowWrap onClick={() => setstep1(prev => !prev)}>
            {step1 ? <UpIcon /> : <DownIcom />}
          </ArrowWrap>
        </BoxWrap>

        {step1 && (
          <BG width={628} height={137} imgUrl={text01} />
        )}

      </NoticWrap>
      <BG width={710} height={44} imgUrl={shadow} />
      <BG width={710} height={2321} imgUrl={img02} />
    </div >
  )
}
export default ProEventComponent;